export default __webpack_public_path__ + "static/media/community.55ec245f.png";